import { Fragment, useState } from 'react'
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap'
import { Btn } from '../../../AbstractElements';
import { CommonPopoverType } from '../../../Types/CommonComponentType';

const CommonPopover = ({ data }: CommonPopoverType) => {
    const [popover, setPopover] = useState(false);
    const toggle = () => setPopover(!popover);
    return (
        <Fragment>
            <Btn color={`${data.btnColor}`} className="example-popover mb-0 me-0" id={`${'Popover-' + data.id}`}>{data.btnText}</Btn >
            <Popover placement={data.placement} isOpen={popover} target={'Popover-' + data.id}
                toggle={toggle} trigger={data.trigger}>
                <PopoverHeader>{data.popoverHeader}</PopoverHeader>
                <PopoverBody>{data.popoverBody}</PopoverBody>
            </Popover>
        </Fragment>
    )
}
export default CommonPopover